import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../../styles/common/toast.css";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaInfoCircle,
} from "react-icons/fa";

const iconMap = {
  success: <FaCheckCircle className="toast__icon toast__icon--success" />,
  error: <FaExclamationCircle className="toast__icon toast__icon--error" />,
  info: <FaInfoCircle className="toast__icon toast__icon--info" />,
};

const Toast = ({ message, type, onClose, duration = 3000 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false); // bật hiệu ứng fade-out
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  // Khi hiệu ứng fade-out kết thúc thì gọi onClose để remove toast khỏi DOM
  const handleAnimationEnd = () => {
    if (!visible) {
      onClose();
    }
  };

  return (
    <div
      className={`toast toast--${type} ${visible ? "show" : ""}`}
      onAnimationEnd={handleAnimationEnd}
      role="alert"
      aria-live="assertive"
    >
      {iconMap[type]}
      <span className="toast__message">{message}</span>
      <button
        className="toast__close"
        onClick={() => setVisible(false)}
        aria-label="Đóng thông báo"
      >
        &times;
      </button>
      <div className="toast__progress" />
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "error", "info"]).isRequired,
  onClose: PropTypes.func.isRequired,
  duration: PropTypes.number,
};

export default Toast;
